import { render, staticRenderFns } from "./ComicDetails.vue?vue&type=template&id=4d368075&scoped=true&"
import script from "./ComicDetails.vue?vue&type=script&lang=js&"
export * from "./ComicDetails.vue?vue&type=script&lang=js&"
import style0 from "./ComicDetails.vue?vue&type=style&index=0&id=4d368075&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d368075",
  null
  
)

export default component.exports